// extracted by mini-css-extract-plugin
export var drawerContent = "_33-0";
export var valueBlock = "_33-1";
export var valueBlockFrom = "_33-2 _33-1";
export var valueBlockTo = "_33-3 _33-1";